import type { ConfirmOpts } from './dialogs.js';

/** ehr#584 (Chase 10-23): Stop sharing a chart file asks first, naming the file and the client. */
export function stopSharingConfirm(fileName: string, clientName: string): ConfirmOpts {
  return {
    message: `Stop sharing ${fileName} with ${clientName || 'this client'}? It comes out of their client portal.`,
    confirmLabel: 'Stop sharing',
    cancelLabel: 'Cancel',
  };
}
